// PATH: src/api/axiosConfig.js
// VERSION: 1.1 — baseURL desde ENV + interceptores simples

import axios from 'axios';
import ENV from '../config/adminEnv';

const axiosInstance = axios.create({
  baseURL: ENV.API_BASE_URL || '/api',
  timeout: 15000,
});

axiosInstance.interceptors.response.use(
  (r) => r,
  (err) => {
    const msg = err?.response?.data?.error || err.message || 'Error de red';
    // eslint-disable-next-line no-console
    console.error('[API ERROR]', msg, err?.response || '');
    return Promise.reject(err);
  }
);

export default axiosInstance;
